'use client'
import { useMemo } from 'react'
import clsx from 'clsx'

import { RaIcon, RaTypography } from '@components/core/index.core'
import { ICONS } from '@constants/icons.constants'
import { useUi } from '@contexts/ui.context'

import styles from './ra-toaster.module.scss'

export const RaToaster = () => {
  const { toaster } = useUi()

  const toasterClass = useMemo(() => {
    return clsx(styles['ra-toaster'], toaster.isOpen && styles['open'])
  }, [toaster])

  return (
    <div className={toasterClass}>
      {toaster.severity === 'success' && (
        <RaIcon
          icon={ICONS.SUCCESS}
          minWidth={32}
        />
      )}
      <div>
        <RaTypography
          weight="semibold"
          component="span">
          {toaster.title}
        </RaTypography>
        {toaster.content && (
          <RaTypography component="span">{toaster.content}</RaTypography>
        )}
      </div>
    </div>
  )
}
